import { sanitizeHtmlAllowlist } from './sanitizeHtmlAllowlist';

/** Plain text for validation (empty check, length). */
export function htmlToPlainText(html) {
  if (html == null || html === '') return '';
  const doc = new DOMParser().parseFromString(String(html), 'text/html');
  return (doc.body.textContent || '').replace(/\u00a0/g, ' ').trim();
}

export function sanitizeTicketDescriptionHtml(html) {
  return sanitizeHtmlAllowlist(html);
}

export function looksLikeHtml(content) {
  if (content == null || content === '') return false;
  return /<[a-z][\s\S]*>/i.test(String(content));
}
